// src/pages/Home.tsx
import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserRoleContext } from '../context/UserRoleContext';
import { EventContext } from '../context/EventContext';
import { ROUTES } from '../constants/routes';
import HomePageButtonsWrapper from '../components/HomeButtonComponent';
import loginBackground from '../assets/loginBackgroundwelike.jpg';


const Home: React.FC = () => {
const navigate = useNavigate();
const { userRole } = useContext(UserRoleContext);
const { currentEvent } = useContext(EventContext);


return (
  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>                          
  <h1 style={{ fontSize: '40px', maxWidth: '90%', textAlign: 'center'}}></h1>
<div style={styles.splitPanel}>

        <HomePageButtonsWrapper
  title="Cyne Up For An Event"
  isShown={true}
  route={ROUTES.CREATE_REGISTRANT}
  icon={'join-event'}
/>

        <HomePageButtonsWrapper
  title={`View ${ currentEvent?.event_name } Details`}
  isShown={currentEvent != null}
  route={ROUTES.EVENT_OVERVIEW}
  icon={'view-event'}
/>

        <HomePageButtonsWrapper
  title={`View All My Events`}
  isShown={true}
  route={ROUTES.SWITCH_EVENTS}
  icon={'view-all-events'}
/>

        <HomePageButtonsWrapper
  title={`View ${userRole?.organization_name} Organization`}
  isShown={userRole?.organization_id != null && userRole?.organization_id != ''}
  route={ROUTES.ORGANIZATION_OVERVIEW}
  icon={'view-host'}
/>

        <HomePageButtonsWrapper
  title={`View ${userRole?.host_name} Details`}
  isShown={userRole?.host_id != null && userRole?.host_id != ''}
  route={ROUTES.HOST_OVERVIEW}
  icon={'view-host'}
/>

        <HomePageButtonsWrapper
  title={`${ currentEvent ? `Create a New Event` : `Create an Event`}`}
  isShown={true}
  route={ROUTES.CHOOSE_HOST}
  icon={'create-event'}
/>

  
                        {/* <div className='card' style={styles.panel}>
                            <h1>Events</h1>
                            <button style={styles.createButton} onClick={() => navigate(ROUTES.CREATE_REGISTRANT)}>Cyne Up For an Event</button>
                            {currentEvent && <button style={styles.createButton} onClick={() => navigate(ROUTES.EVENT_OVERVIEW)}>View { currentEvent.event_name } Details</button>}
                            <button style={styles.createButton} onClick={() => navigate(ROUTES.SWITCH_EVENTS)}>View All My Events</button>

                                                        {userRole?.organization_id && <button style={styles.createButton} onClick={() => navigate(ROUTES.ORGANIZATION_OVERVIEW)}>View {userRole.organization_name} Organization</button>}
                            {userRole?.host_id && <button style={styles.createButton} onClick={() => navigate(ROUTES.HOST_OVERVIEW)}>View {userRole.host_name} Details</button>}
                            <button style={styles.createButton} onClick={() => navigate(ROUTES.CHOOSE_HOST)}>{ currentEvent ? `Create a New Event` : `Create an Event`}</button>

                        </div> */}
{/* 
                        {(userRole?.host_id || userRole?.organization_id ) && <div className='card' style={styles.panel}>
                            <h1 style={{textAlign: 'center'}}>Hosts</h1>

                            {/* <button style={styles.createButton} onClick={() => navigate(ROUTES.HOST_ORG_OVERVIEW)}>Create a New Host</button> */}

                        {/* </div>} */}


                    </div>

                    </div>

                    );

};

const styles = {
    dashboardContainer: {
        display: 'flex',
    },
    contentContainer: {
        padding: '20px',
        flex: 1,
    },
    splitPanel: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '30px',
        width: '90%'
    } as React.CSSProperties,
    panel: {
        width: '45%',
        minWidth: '350px',
        padding: '20px',
        border: '1px solid #ccc',
        placeItems: 'center',
        maxWidth: '500px'
    },
    createButton: {
        width: '100%',
        padding: '10px',
        marginTop: '20px',
        cursor: 'pointer',
        fontSize: '20px',
        minWidth: '350px',
        minHeight: '50px',
        whiteSpace: 'normal'
    }
};

export default Home;
